import React from 'react';
import { createRoot } from 'react-dom/client';
import HomePage from './components/HomePage';

// Import Bootstrap CSS
import 'bootstrap/dist/css/bootstrap.min.css';

// Import global styles
import './assets/css/global.css';

// Main App Component
const App = () => {
  return (
    <div className="App">
      <HomePage />
    </div>
  );
};

// Render the app
const container = document.getElementById('root');
const root = createRoot(container);
root.render(<App />);
